import { memo, useEffect, useState, useCallback } from 'react';
import { BzButton, BzTab, BzTabs, BzTabsContainer, BzTabsContent } from '../../components';
import { TabEquityContent, TabOptionsContent, TabAllContent, TabFutureContent, TabPagesContent, TabRecommContent, TabAlertsContent, TabEventsContent, TabIPOContent, TabNewsContent, TabOptionsListContent } from '.';
import { useDispatch, useSelector } from 'react-redux';
import { getSearchAllScrips, getSearchScripsEquity, getSearchScripsFutures, resetSearchData, setArrRecentlySearchScrips, getSearchScripsOptions, searchOptionsSuccess } from '../../redux/actions/globalSearch';
import { GLOBAL_SEARCH_MIN_LENGTH, WATCHLIST_GRID_INDEX, MAX_SEARCH_SCRIP_PER_PAGE, GLOBAL_SEARCH_TABS, LOCATIONS, LOCAL_STORAGE_KEYS, IPO_MODALS } from '../../utils/global_variables';
import { Col, Row, Container } from 'react-bootstrap';
import { handleModal, handleModalData } from '../../redux/actions/modals';
import { useLocation, useNavigate } from "react-router-dom";
import { setScripOverviewData } from '../../redux/actions/marketOverview';
import { getDecryptLocalStorage, getStorageWithMultiTabCheck, setEncryptLocalStorage } from '../../utils/global_functions';
import { _getSearchScrips } from '../../controllers';
import moment from 'moment';
import { useLoader } from '../../hooks';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
const TabsScripsList = (props) => {
    const {
        onBuySellClick,// Ameersha N : 07-11-2023 : BT-96728 Global Search feature – Issue - addedScrips state not getting empty  – Start&End
        isExpand, isDefaultAllTab, isGlobalSearch = false, setShow = () => { }, strGlobalSearchActiveTab, onHandleDone, isGlobal = false, isSearchScrips,
        strSearchInputText, addScrips, removeScrips, scripDetails, strWatchlistName, orderBookSearchModal,
        isSpanMargin = false, handleSelectedPage, handleEditAlert, handleNewsOverview, handleOverview,
        onBuySellClickRecomm, setOrderBookSearchModal, checkBuyExisting, checkSellExisting, bSpanMargin, isKeyboard = true } = props;


    // scripDetails is array consist of scrips added from search
    // addScrips is function click on plus icon in search scrip listing
    // removeScrips is function click on minus icon in search scrip listing
    // isSpanMargin is added---BT-107433_SrikanthRao_9-10-2023_Calculator || Functional Implementation||

    const dispatch = useDispatch();
    let navigate = useNavigate();
    const location = useLocation();
    const objLoginSession = useSelector(state => state.auth.objLoginSession);
    //BT-115300,BT-115302 : Implementing search functionality for News,IPO : Manasa B : 24/08/2023 - Start
    const { data: arrFilteredNews, count: nNewsCount } = useSelector(state => state.globalSearch.arrFilteredNews);
    const { data: arrIPOScrips, count: nIPOCount } = useSelector(state => state.globalSearch.arrFilteredIPO);
    //BT-115300,BT-115302 : Implementing search functionality for News,IPO : Manasa B : 24/08/2023 - End
    //BT-115298 ,BT-115303 : Implementing search functionality for Recommendation,ALerts : ManasaB : 16/08/2023 - Start
    const { data: arrFilteredRecoScrips, count: nRecommendationCount } = useSelector(state => state.globalSearch.arrFilteredRecommendations);
    const { data: arrFilteredAlerts, count: nAlertsCount } = useSelector(state => state.globalSearch.arrFilteredAlerts);
    //BT-115298 ,BT-115303 : Implementing search functionality for Recommendation,ALerts : ManasaB : 16/08/2023 - End
    const { data: arrAllScrips, count: nAllCount } = useSelector(state => state.globalSearch.searchAllScrips);
    const { data: arrEqScrips, count: nEQCount } = useSelector(state => state.globalSearch.searchEqScrips);
    const { data: arrFutScrips, count: nFUCount } = useSelector(state => state.globalSearch.searchFutScrips);
    //BT-115299 : Implementing search functionality for Events : ManasaB : 17/08/2023 - Start
    const { data: arrFilteredEvents, count: nEventsCount } = useSelector(state => state.globalSearch.arrFilteredEvents);
    //BT-115299 : Implementing search functionality for Events : ManasaB : 17/08/2023 - End
    const { data: arrOptScrips, count: nOPCount } = useSelector(state => state.globalSearch.searchOptScrips);
    const { data: arrPages, count: nPageCount } = useSelector(state => state.globalSearch.searchPages);
    const objSearchScripData = useSelector(state => state.globalSearch.objSearchScripDataStatus);
    //Vaibhav Singh: BT-109089: 15-11-23: Called UserId : Start
    const { userId } = useSelector(state => state.auth);
    const [bIsNoDataSpanMargin, setBIsNoDataSpanMargin] = useState(false);//ManasaB : 10-09-2024 : Hotfix issue
    //Vaibhav Singh: BT-109089: 15-11-23: Called UserId : End
    const [strSearchActiveTab, setStrSearchActiveTab] = useState(isDefaultAllTab ? 'all' : 'equity');
    const [PAGE_FROM, setPageFrom] = useState(MAX_SEARCH_SCRIP_PER_PAGE);
    const [tabArray, setTabArray] = useState([]);
    const [nActiveCard, setNActiveCard] = useState(isKeyboard ? 0 : -1);// Azeem K :11-10-2024 : state for active scrip for highliting in scrip list it will be handle by up and down key of keyboard
    const [availableOptions, setAvailableOptions] = useState([]);
    const [activeButton, setActiveButton] = useState(null);
    const loading = useSelector(state => state?.globalSearch?.isLoading);
    const { numLoader, loaderRef } = useLoader();
    useEffect(() => {
        let temp = [];
        if (isDefaultAllTab && nAllCount > 0) {
            temp.push(GLOBAL_SEARCH_TABS.ALL);
        }
        if (nEQCount > 0) {
            temp.push(GLOBAL_SEARCH_TABS.EQUITY);
        }
        if (nFUCount > 0) {
            temp.push(GLOBAL_SEARCH_TABS.FUTURES);
        }
        if (nOPCount > 0) {
            temp.push(GLOBAL_SEARCH_TABS.OPTIONS);
        }
        if (isGlobalSearch) {
            if (nNewsCount > 0) {
                temp.push(GLOBAL_SEARCH_TABS.NEWS);
            }
            if (nIPOCount > 0) {
                temp.push(GLOBAL_SEARCH_TABS.IPO);
            }
            if (nRecommendationCount > 0) {
                temp.push(GLOBAL_SEARCH_TABS.RECOMMENDATIONS);
            }
            if (nAlertsCount > 0) {
                temp.push(GLOBAL_SEARCH_TABS.ALERTS);
            }
            if (nEventsCount > 0) {
                temp.push(GLOBAL_SEARCH_TABS.EVENTS);
            }
            if (nPageCount > 0) {
                temp.push(GLOBAL_SEARCH_TABS.PAGES);
            }
        }
        setTabArray(temp);
    }, [isDefaultAllTab, nAlertsCount, nAllCount, nEQCount, nEventsCount, nFUCount, nIPOCount, nNewsCount, nOPCount, nPageCount, nRecommendationCount]);

    useEffect(() => {
        //ManasaB : 23-09-2024 : Ordercart Infinite loop issue - Start
        //BREEZE-5912 : Order Cart for Derivative segment : LLD : ManasaB : 08-04-2025 : Remove restriction to show only e scrips - Start
        if (!orderBookSearchModal) {
            if (!strSearchInputText || strSearchInputText?.length < GLOBAL_SEARCH_MIN_LENGTH) {
                setStrSearchActiveTab(isDefaultAllTab ? GLOBAL_SEARCH_TABS.ALL : GLOBAL_SEARCH_TABS.EQUITY);
            } else {
            }
            //BT-114879 : Creating common function for search : ManasaB : 01/08/2023 - Start
            // setCurrPageNo(0);


            if (isGlobalSearch===false) {
                if (arrAllScrips?.length > 0 && arrEqScrips?.length === 0 && arrFutScrips?.length === 0 && arrOptScrips?.length === 0) {
                    setStrSearchActiveTab(GLOBAL_SEARCH_TABS.ALL);
                }
            }
            else {
                //BT-107433 : Calculator : SAT2 Bug Fixing : Manasab : 23-03-2024 -Start
                if (isSpanMargin) {
                    if (arrFutScrips.length > 0 && arrOptScrips.length == 0) {
                        setStrSearchActiveTab(GLOBAL_SEARCH_TABS.FUTURES);
                    }
                    else if (arrFutScrips.length == 0 && arrOptScrips.length > 0) {
                        setStrSearchActiveTab(GLOBAL_SEARCH_TABS.OPTIONS);
                    }
                }
                //BT-107433 : Calculator : SAT2 Bug Fixing : Manasab : 23-03-2024 -End
                else {
                    if (arrEqScrips?.length == 0 && arrFutScrips?.length > 0 && arrOptScrips?.length > 0) {
                        setStrSearchActiveTab(GLOBAL_SEARCH_TABS.FUTURES);
                    }
                    else if (arrEqScrips?.length == 0 && arrFutScrips?.length > 0 && arrOptScrips?.length == 0) {
                        setStrSearchActiveTab(GLOBAL_SEARCH_TABS.FUTURES);
                    }
                    else if (arrEqScrips?.length == 0 && arrFutScrips?.length == 0 && arrOptScrips?.length > 0) {
                        setStrSearchActiveTab(GLOBAL_SEARCH_TABS.OPTIONS);
                    }
                    else if (arrEqScrips?.length > 0 && arrFutScrips?.length > 0 && arrOptScrips?.length < 0) {
                        setStrSearchActiveTab(isDefaultAllTab ? GLOBAL_SEARCH_TABS.ALL : GLOBAL_SEARCH_TABS.EQUITY);
                    }
                    else if (arrEqScrips?.length > 0 && arrFutScrips?.length == 0 && arrOptScrips?.length == 0 && arrPages?.length > 0) {
                        setStrSearchActiveTab(GLOBAL_SEARCH_TABS.EQUITY);
                    }
                    else if (arrEqScrips?.length == 0 && arrFutScrips?.length == 0 && arrOptScrips?.length == 0 &&
                        arrFilteredRecoScrips?.length > 0 && arrFilteredAlerts?.length > 0 && arrFilteredEvents?.length > 0 &&
                        arrFilteredNews?.length == 0 && arrIPOScrips?.length > 0) {
                        setStrSearchActiveTab(GLOBAL_SEARCH_TABS.NEWS);
                    }
                    else if (arrEqScrips?.length == 0 && arrFutScrips?.length == 0 && arrOptScrips?.length == 0 &&
                        arrFilteredRecoScrips?.length > 0 && arrFilteredAlerts?.length > 0 && arrFilteredEvents?.length > 0 &&
                        arrFilteredNews?.length == 0 && arrIPOScrips?.length > 0) {
                        setStrSearchActiveTab(GLOBAL_SEARCH_TABS.ALERTS);
                    }
                    else if (arrEqScrips?.length == 0 && arrFutScrips?.length == 0 && arrOptScrips?.length == 0 &&
                        arrFilteredRecoScrips?.length > 0 && arrFilteredAlerts?.length == 0 && arrFilteredEvents?.length > 0 &&
                        arrFilteredNews?.length == 0 && arrIPOScrips?.length > 0) {
                        setStrSearchActiveTab(GLOBAL_SEARCH_TABS.RECOMMENDATIONS);
                    }
                    else if (arrEqScrips?.length == 0 && arrFutScrips?.length == 0 && arrOptScrips?.length == 0 &&
                        arrFilteredRecoScrips?.length == 0 && arrFilteredAlerts?.length == 0 && arrFilteredEvents?.length > 0 &&
                        arrFilteredNews?.length == 0 && arrIPOScrips?.length > 0) {
                        setStrSearchActiveTab(GLOBAL_SEARCH_TABS.EVENTS);
                    }
                    else if (arrEqScrips?.length == 0 && arrFutScrips?.length == 0 && arrOptScrips?.length == 0 &&
                        arrFilteredRecoScrips?.length == 0 && arrFilteredAlerts?.length == 0 && arrFilteredEvents?.length == 0 &&
                        arrFilteredNews?.length == 0 && arrIPOScrips?.length > 0) {
                        setStrSearchActiveTab(GLOBAL_SEARCH_TABS.IPO);
                    }
                    else if (arrEqScrips?.length == 0 && arrFutScrips?.length == 0 && arrOptScrips?.length == 0 &&
                        arrFilteredRecoScrips?.length == 0 && arrFilteredAlerts?.length == 0 && arrFilteredEvents?.length == 0 &&
                        arrFilteredNews?.length == 0 && arrIPOScrips?.length == 0 && arrPages?.length > 0) {
                        setStrSearchActiveTab(GLOBAL_SEARCH_TABS.PAGES);
                    }
                }
            }
            //BT-114879 : Creating common function for search : ManasaB : 01/08/2023 - End
        }
        else {
            //BREEZE-5912 : Order Cart for Derivative segment : ManasaB : 28-04-2025  - Start
            if (arrAllScrips.length > 0) {
                setStrSearchActiveTab(GLOBAL_SEARCH_TABS.ALL);
            }
            //BREEZE-5912 : Order Cart for Derivative segment : ManasaB : 28-04-2025 - End
            // if (orderBookSearchModal == true && objSearchScripData.status) {
            //     setStrSearchActiveTab(GLOBAL_SEARCH_TABS.EQUITY);//BT-114263 : Removing "All" tab and Adding count in search tabs : ManasaB : 24/07/2023
            //     //BT-124975 : ManasaB :11/01/2024 : Order Cart : API Integration for Save Cart and Place Order - Start
            //     if (strSearchInputText.length >= GLOBAL_SEARCH_MIN_LENGTH) {
            //         useDebounce(() => {
            //             // if (arrEqScrips.length == 0) {
            //             dispatch(getSearchScripsEquity(strSearchInputText?.toUpperCase(), -1, 0, 25));
            //             // }
            //         }, 1000);
            //     }
            //     //BT-124975 : ManasaB :11/01/2024 : Order Cart : API Integration for Save Cart and Place Order - End
            // }

        }
        //BREEZE-5912 : Order Cart for Derivative segment : LLD : ManasaB : 08-04-2025 : Remove restriction to show only eq scrips - End
        //ManasaB : 23-09-2024 : Ordercart Infinite loop issue - End
    }, [dispatch, orderBookSearchModal, strSearchInputText, arrEqScrips, arrFutScrips, arrOptScrips, arrAllScrips, arrFilteredAlerts?.length, arrFilteredEvents?.length, arrFilteredNews?.length, arrFilteredRecoScrips?.length, arrIPOScrips?.length, arrPages?.length, isDefaultAllTab, isSpanMargin]);
    //BT-124975 : ManasaB :11/01/2024 : Order Cart : API Integration for Save Cart and Place Order - Start

    useEffect(() => {
        if (orderBookSearchModal && strSearchInputText.length === 0) { //ManasaB : 19/01/2024 : Unit testing bug resolve
            setOrderBookSearchModal(false);
        }
    }, [arrEqScrips, strSearchInputText]);
    //BT-124975 : ManasaB :11/01/2024 : Order Cart : API Integration for Save Cart and Place Order - End
    useEffect(() => {
        if (isKeyboard && strSearchInputText?.length > 0) {
            setNActiveCard(0);
        }
    }, [strSearchInputText, isKeyboard]);
    useEffect(() => {
        if (strGlobalSearchActiveTab) {
            setStrSearchActiveTab(strGlobalSearchActiveTab);
        } else { }
    }, [strGlobalSearchActiveTab]);

    useEffect(() => {
        return () => {
            dispatch(resetSearchData());
        };
    }, [strSearchInputText, dispatch]);

    const handleSearchScripsScroll = useCallback(async (e) => {
        if (e.target.scrollHeight <= Math.round(e.target.scrollTop + e.target.offsetHeight + 5)) {
            // if ((strSearchActiveTab === 'equity') && strSearchInputText?.length >= GLOBAL_SEARCH_MIN_LENGTH) { //BT-114263 : Removing "All" tab and Adding count in search tabs : ManasaB : 24/07/2023

            //     dispatch(getSearchScrips(strSearchInputText?.toUpperCase(), -1, pageFrom + 1, MAX_SEARCH_SCRIP_PER_PAGE));
            //     setCurrPageNo(curr => curr + 1);
            // } else { }
            //Vaibhav Singh: BT-109089: 15-11-23: Added Exchange allowed segments : Start
            const mktAllowed = JSON.parse(getStorageWithMultiTabCheck(`${LOCAL_STORAGE_KEYS.USER_DETAILS}_${userId}`));
            switch (strSearchActiveTab) {
                case GLOBAL_SEARCH_TABS.ALL: {
                    if (arrAllScrips.length < nAllCount) {
                        dispatch(getSearchAllScrips(strSearchInputText?.toUpperCase(), mktAllowed?.nExchangesViewAllowed ? mktAllowed?.nExchangesViewAllowed : -1, PAGE_FROM, MAX_SEARCH_SCRIP_PER_PAGE));
                    }
                    setPageFrom(prevState => prevState + MAX_SEARCH_SCRIP_PER_PAGE);
                    break;
                }
                case GLOBAL_SEARCH_TABS.EQUITY: {
                    if (arrEqScrips.length < nEQCount) {
                        dispatch(getSearchScripsEquity(strSearchInputText?.toUpperCase(), mktAllowed?.nExchangesViewAllowed ? mktAllowed?.nExchangesViewAllowed : -1, PAGE_FROM, MAX_SEARCH_SCRIP_PER_PAGE));
                    }
                    setPageFrom(prevState => prevState + MAX_SEARCH_SCRIP_PER_PAGE);
                    break;
                }
                case GLOBAL_SEARCH_TABS.FUTURES: {
                    if (arrFutScrips.length < nFUCount) {
                        dispatch(getSearchScripsFutures(strSearchInputText?.toUpperCase(), mktAllowed?.nExchangesViewAllowed ? mktAllowed?.nExchangesViewAllowed : -1, PAGE_FROM, MAX_SEARCH_SCRIP_PER_PAGE));
                    }
                    setPageFrom(prevState => prevState + MAX_SEARCH_SCRIP_PER_PAGE);
                    break;
                }
                case GLOBAL_SEARCH_TABS.OPTIONS: {
                    if ((isDefaultAllTab || isSpanMargin) && !isGlobalSearch) {
                        if (arrOptScrips.length < nOPCount) {
                            dispatch(getSearchScripsOptions(strSearchInputText?.toUpperCase(), mktAllowed?.nExchangesViewAllowed ? mktAllowed?.nExchangesViewAllowed : -1, PAGE_FROM, MAX_SEARCH_SCRIP_PER_PAGE, isDefaultAllTab));
                        }
                    } else {
                        let nOptLength = 0;
                        const objResp = await _getSearchScrips(strSearchInputText?.toUpperCase(), mktAllowed, PAGE_FROM, MAX_SEARCH_SCRIP_PER_PAGE, isGlobalSearch ? false : isDefaultAllTab, [], isSpanMargin);
                        if (objResp?.status) {
                            //BT-114442 : Option tab functionality : ManasaB : 11/08/2023 : To get max date - Start
                            if (!isDefaultAllTab && !isSpanMargin) {
                                objResp.data?.arrOptSearchData?.forEach((eachOptData) => {
                                    let dates = [];
                                    nOptLength = nOptLength + eachOptData.optexp.buckets.length; //Hiral Mam suggested options tab length should be total no of expiries : ManasaB : 22/08/2023
                                    eachOptData.optexp.buckets.forEach(eachDate => {
                                        dates.push(new Date(moment(eachDate.key, "DDMMMYYYY").format("YYYY-MM-DD")));
                                    });
                                    eachOptData.dates = dates;
                                });
                                objResp.data?.arrOptSearchData?.forEach((eachOptData) => {
                                    let maxDate = new Date(Math.max(...eachOptData.dates));
                                    eachOptData.maxDate = moment(maxDate, "YYYY-MM-DD").format("MMMYY");
                                    delete eachOptData["dates"];
                                });
                            }
                            //BT-114442 : Option tab functionality : ManasaB : 11/08/2023 - End
                            const arrOptionTabsearchData = (isDefaultAllTab || isSpanMargin) ? objResp.data.arrOptSearchListingData : objResp.data.arrOptSearchData;
                            const nOptiondataLength = (isDefaultAllTab || isSpanMargin) ? objResp.data.nOptListDataCount : nOptLength;
                            if (arrOptionTabsearchData && arrOptionTabsearchData.length > 0) {
                                dispatch(searchOptionsSuccess({ data: arrOptionTabsearchData, count: nOptiondataLength }));//Hiral Mam suggested options tab length should be total no of expiries : ManasaB : 22/08/2023
                            }
                            setStrSearchActiveTab('options');
                        }
                    }
                    setPageFrom(prevState => prevState + MAX_SEARCH_SCRIP_PER_PAGE);
                    break;
                }
                default: {
                    break;
                }
                //Vaibhav Singh: BT-109089: 15-11-23: Added Exchange allowed segments : End
            }
        } else {

        }
    }, [PAGE_FROM, arrAllScrips, arrEqScrips, arrFutScrips, isSpanMargin, userId, arrOptScrips, dispatch, isDefaultAllTab, nAllCount, nEQCount, nFUCount, nOPCount, strSearchActiveTab, strSearchInputText]);
    const handleSearchTabsOnClick = (e, currTab) => {
        if (isKeyboard) {
            setNActiveCard(0);
        }

        e.stopPropagation();

        setPageFrom(MAX_SEARCH_SCRIP_PER_PAGE);
        switch (currTab) {
            case GLOBAL_SEARCH_TABS.ALL: {
                setStrSearchActiveTab(currTab);
                break;
            }
            case GLOBAL_SEARCH_TABS.EQUITY: {
                setStrSearchActiveTab(currTab);
                break;
            }
            case GLOBAL_SEARCH_TABS.FUTURES: {
                setStrSearchActiveTab(currTab);
                break;
            }
            case GLOBAL_SEARCH_TABS.OPTIONS: {
                setStrSearchActiveTab(currTab);
                break;
            }

            case GLOBAL_SEARCH_TABS.PAGES: {
                setStrSearchActiveTab(currTab);
                // if (arrPages?.length === 0) {
                //     dispatch(getSearchPages(strSearchInputText?.toUpperCase()));
                // } else { }
                break;
            }
            //BT-115298 ,BT-115303 : Implementing search functionality for Recommendation,ALerts : ManasaB : 16/08/2023 - Start
            case GLOBAL_SEARCH_TABS.RECOMMENDATIONS: {
                setStrSearchActiveTab(currTab);
                break;
            }
            case GLOBAL_SEARCH_TABS.ALERTS: {
                setStrSearchActiveTab(currTab);
                break;
            }
            //BT-115298 ,BT-115303 : Implementing search functionality for Recommendation,ALerts : ManasaB : 16/08/2023 - End
            //BT-115299 : Implementing search functionality for Events : ManasaB : 17/08/2023 - Start
            case GLOBAL_SEARCH_TABS.EVENTS: {
                setStrSearchActiveTab(currTab);
                break;
            }
            //BT-115299 : Implementing search functionality for Events : ManasaB : 17/08/2023 - End
            //BT-115300,BT-115302 : Implementing search functionality for News,IPO : Manasa B : 24/08/2023 - Start
            case GLOBAL_SEARCH_TABS.IPO: {
                setStrSearchActiveTab(currTab);
                break;
            }
            case GLOBAL_SEARCH_TABS.NEWS: {
                setStrSearchActiveTab(currTab);
                break;
            }
            //BT-115300,BT-115302 : Implementing search functionality for News,IPO : Manasa B : 24/08/2023 - End
            default:
                break;
        }
    };

    useEffect(() => {
        if (isKeyboard) {
            setTimeout(() => {
                if (availableOptions?.length) {
                    setActiveButton(availableOptions[0]);
                }
            }, 300);
        }
    }, [availableOptions]);

    const handleUpandDownKey = useCallback((e) => {

        let key = e?.key;
        let ctrlKey = e?.ctrlKey;
        //Azeem K :11-10-2024 : created a function to handle the active card on click of up and down key
        if (ctrlKey) {
            if (key === 'ArrowUp') {
                setNActiveCard(0);
                return;
            } else if (key === 'ArrowDown') {
                switch (strSearchActiveTab) {
                    case GLOBAL_SEARCH_TABS.ALL: {
                        if (arrAllScrips?.length > 0) {
                            setNActiveCard(arrAllScrips?.length - 1);
                        }
                        break;
                    }
                    case GLOBAL_SEARCH_TABS.EQUITY: {
                        if (arrEqScrips?.length > 0) {
                            setNActiveCard(arrEqScrips?.length - 1);
                        }
                        break;

                    }
                    case GLOBAL_SEARCH_TABS.FUTURES: {
                        if (arrFutScrips?.length > 0) {
                            setNActiveCard(arrFutScrips?.length - 1);
                        }
                        break;
                    }
                    case GLOBAL_SEARCH_TABS.OPTIONS: {
                        if (arrOptScrips?.length > 0) {
                            setNActiveCard(arrOptScrips?.length - 1);
                        }
                        break;
                    }

                    case GLOBAL_SEARCH_TABS.PAGES: {
                        if (arrPages?.length > 0) {
                            setNActiveCard(arrPages?.length - 1);
                        }

                        break;
                    }
                    case GLOBAL_SEARCH_TABS.RECOMMENDATIONS: {
                        if (arrFilteredRecoScrips?.length > 0) {
                            setNActiveCard(arrFilteredRecoScrips?.length - 1);
                        }
                        break;
                    }
                    case GLOBAL_SEARCH_TABS.ALERTS: {
                        if (arrFilteredAlerts?.length > 0) {
                            setNActiveCard(arrFilteredAlerts?.length - 1);
                        }
                        break;
                    }
                    case GLOBAL_SEARCH_TABS.EVENTS: {

                        if (arrFilteredEvents?.length > 0) {
                            setNActiveCard(arrFilteredEvents?.length - 1);
                        }
                        break;
                    }
                    case GLOBAL_SEARCH_TABS.IPO: {
                        if (arrIPOScrips?.length > 0) {
                            setNActiveCard(arrIPOScrips?.length - 1);
                        }
                        break;
                    }
                    case GLOBAL_SEARCH_TABS.NEWS: {
                        if (arrFilteredNews?.length > 0) {
                            setNActiveCard(arrFilteredNews?.length - 1);
                        }
                        break;
                    }
                    default:
                        break;
                }
            } else if (key === 'Enter') {
                if (scripDetails.length > 0) {
                    onHandleDone();
                    return;
                }
            }
        } else if (key === 'ArrowUp') {
            if (nActiveCard === 0) {
                setNActiveCard(0);
                return;
            }
            switch (strSearchActiveTab) {
                case GLOBAL_SEARCH_TABS.ALL: {
                    if (arrAllScrips?.length > 0 && nActiveCard >= 0) {
                        setNActiveCard(curr => curr - 1);
                    }
                    break;
                }
                case GLOBAL_SEARCH_TABS.EQUITY: {

                    if (arrEqScrips?.length > 0 && nActiveCard >= 0) {
                        setNActiveCard(curr => curr - 1);
                    }
                    break;
                }
                case GLOBAL_SEARCH_TABS.FUTURES: {
                    if (arrFutScrips?.length > 0 && nActiveCard >= 0) {
                        setNActiveCard(curr => curr - 1);
                    }
                    break;
                }
                case GLOBAL_SEARCH_TABS.OPTIONS: {

                    if (arrOptScrips?.length > 0 && nActiveCard >= 0) {
                        setNActiveCard(curr => curr - 1);
                    }
                    break;
                }

                case GLOBAL_SEARCH_TABS.PAGES: {

                    if (arrPages?.length > 0 && nActiveCard >= 0) {
                        setNActiveCard(curr => curr - 1);
                    }
                    break;
                }
                case GLOBAL_SEARCH_TABS.RECOMMENDATIONS: {

                    if (arrFilteredRecoScrips?.length > 0 && nActiveCard >= 0) {
                        setNActiveCard(curr => curr - 1);
                    }
                    break;
                }
                case GLOBAL_SEARCH_TABS.ALERTS: {
                    if (arrFilteredAlerts?.length > 0 && nActiveCard >= 0) {
                        setNActiveCard(curr => curr - 1);
                    }
                    break;
                }
                case GLOBAL_SEARCH_TABS.EVENTS: {

                    if (arrFilteredEvents?.length > 0 && nActiveCard >= 0) {
                        setNActiveCard(curr => curr - 1);
                    }
                    break;
                }
                case GLOBAL_SEARCH_TABS.IPO: {
                    if (arrIPOScrips?.length > 0 && nActiveCard >= 0) {
                        setNActiveCard(curr => curr - 1);
                    }
                    break;
                }
                case GLOBAL_SEARCH_TABS.NEWS: {
                    if (arrFilteredNews?.length > 0 && nActiveCard >= 0) {
                        setNActiveCard(curr => curr - 1);
                    }
                    break;
                }
                default:
                    break;
            }
            return;
        } else if (key === 'ArrowDown') {
            switch (strSearchActiveTab) {
                case GLOBAL_SEARCH_TABS.ALL: {
                    if (arrAllScrips?.length > 0 && nActiveCard < arrAllScrips?.length - 1) {
                        setNActiveCard(curr => curr + 1);
                    } else if (arrAllScrips?.length > 0 && nActiveCard === arrAllScrips?.length - 1) {
                        setNActiveCard(arrAllScrips?.length - 1);
                    }
                    break;
                }
                case GLOBAL_SEARCH_TABS.EQUITY: {
                    if (arrEqScrips?.length > 0 && nActiveCard < arrEqScrips?.length - 1) {
                        setNActiveCard(curr => curr + 1);
                    } else if (arrEqScrips?.length > 0 && nActiveCard === arrEqScrips?.length - 1) {
                        setNActiveCard(arrEqScrips?.length - 1);
                    }
                    break;

                }
                case GLOBAL_SEARCH_TABS.FUTURES: {
                    if (arrFutScrips?.length > 0 && nActiveCard < arrFutScrips?.length - 1) {
                        setNActiveCard(curr => curr + 1);
                    } else if (arrFutScrips?.length > 0 && nActiveCard === arrFutScrips?.length - 1) {
                        setNActiveCard(arrFutScrips?.length - 1);
                    }
                    break;
                }
                case GLOBAL_SEARCH_TABS.OPTIONS: {
                    if (arrOptScrips?.length > 0 && nActiveCard < arrOptScrips?.length - 1) {
                        setNActiveCard(curr => curr + 1);
                    } else if (arrOptScrips?.length > 0 && nActiveCard === arrOptScrips?.length - 1) {
                        setNActiveCard(arrOptScrips?.length - 1);
                    }
                    break;
                }

                case GLOBAL_SEARCH_TABS.PAGES: {
                    if (arrPages?.length > 0 && nActiveCard < arrPages?.length - 1) {
                        setNActiveCard(curr => curr + 1);
                    } else if (arrPages?.length > 0 && nActiveCard === arrPages?.length - 1) {
                        setNActiveCard(arrPages?.length - 1);
                    }

                    break;
                }
                case GLOBAL_SEARCH_TABS.RECOMMENDATIONS: {
                    if (arrFilteredRecoScrips?.length > 0 && nActiveCard < arrFilteredRecoScrips?.length - 1) {
                        setNActiveCard(curr => curr + 1);
                    } else if (arrFilteredRecoScrips?.length > 0 && nActiveCard === arrFilteredRecoScrips?.length - 1) {
                        setNActiveCard(arrFilteredRecoScrips?.length - 1);
                    }
                    break;
                }
                case GLOBAL_SEARCH_TABS.ALERTS: {
                    if (arrFilteredAlerts?.length > 0 && nActiveCard < arrFilteredAlerts?.length - 1) {
                        setNActiveCard(curr => curr + 1);
                    } else if (arrFilteredAlerts?.length > 0 && nActiveCard === arrFilteredAlerts?.length - 1) {
                        setNActiveCard(arrFilteredAlerts?.length - 1);
                    }
                    break;
                }
                case GLOBAL_SEARCH_TABS.EVENTS: {

                    if (arrFilteredEvents?.length > 0 && nActiveCard < arrFilteredEvents?.length - 1) {
                        setNActiveCard(curr => curr + 1);
                    } else if (arrFilteredEvents?.length > 0 && nActiveCard === arrFilteredEvents?.length - 1) {
                        setNActiveCard(arrFilteredEvents?.length - 1);
                    }
                    break;
                }
                case GLOBAL_SEARCH_TABS.IPO: {
                    if (arrIPOScrips?.length > 0 && nActiveCard < arrIPOScrips?.length - 1) {
                        setNActiveCard(curr => curr + 1);
                    } else if (arrIPOScrips?.length > 0 && nActiveCard === arrIPOScrips?.length - 1) {
                        setNActiveCard(arrIPOScrips?.length - 1);
                    }
                    break;
                }
                case GLOBAL_SEARCH_TABS.NEWS: {
                    if (arrFilteredNews?.length > 0 && nActiveCard < arrFilteredNews?.length - 1) {
                        setNActiveCard(curr => curr + 1);
                    } else if (arrFilteredNews?.length > 0 && nActiveCard === arrFilteredNews?.length - 1) {
                        setNActiveCard(arrFilteredNews?.length - 1);
                    }
                    break;
                }
                default:
                    break;
            }
        } else { }
    }, [arrAllScrips, arrEqScrips, arrFilteredAlerts, arrFilteredEvents, arrFilteredNews, arrFilteredRecoScrips, arrFutScrips, arrIPOScrips, arrOptScrips, arrPages, nActiveCard, onHandleDone, scripDetails.length, strSearchActiveTab]);

    const handleTabSwitchKey = useCallback((e) => {
        let key = e?.key;
        let ctrlKey = e?.ctrlKey;
        let shiftKey = e?.shiftKey;

        let index = tabArray.findIndex(x => x === strSearchActiveTab);
        let buttonIndex = -1;
        if (availableOptions?.length) {
            buttonIndex = availableOptions?.findIndex(x => x === activeButton);
        }
        if (key === 'Tab') {
            e.preventDefault();
            // e.stopPropagation()
            if (availableOptions?.length) {
                setActiveButton(availableOptions?.length - 1 === buttonIndex ? availableOptions[0] : availableOptions[buttonIndex + 1]);
            }
            if (shiftKey) {
                setActiveButton(buttonIndex === 0 ? availableOptions[availableOptions?.length - 1] : availableOptions[buttonIndex - 1]);
            }
        }
        if (ctrlKey) {
            if (key === 'ArrowRight') {
                setActiveButton(null);
                setAvailableOptions([]);
                setNActiveCard(0);
                setStrSearchActiveTab(tabArray[index === tabArray?.length - 1 ? index : index + 1]);
            } else if (key === 'ArrowLeft') {
                setActiveButton(null);
                setAvailableOptions([]);
                setNActiveCard(0);
                setStrSearchActiveTab(tabArray[index === 0 ? index : index - 1]);
            }
        }

    }, [activeButton, availableOptions, strSearchActiveTab, tabArray]);

    useEffect(() => {
        if (nActiveCard >= 0) {
            const card = document.getElementById('globalsearchCard' + strSearchActiveTab + nActiveCard);
            if (card) {
                card.focus();
            }
        }
    }, [nActiveCard, strSearchActiveTab]);
    useEffect(() => {
        if (isKeyboard) {
            document.addEventListener("keydown", handleUpandDownKey);
        }
        return () => document.removeEventListener("keydown", handleUpandDownKey);
    }, [handleUpandDownKey]);
    useEffect(() => {
        if (isKeyboard) {
            document.addEventListener("keydown", handleTabSwitchKey);
        }
        return () => document.removeEventListener("keydown", handleTabSwitchKey);
    }, [handleTabSwitchKey]);


    const handleKeyPressOnTabs = (e) => {
        if (isKeyboard) {
            if (e?.code == "ArrowDown" || e?.code == "ArrowUp") {
                e?.preventDefault();
            }
            // Azeem k :11-10-2024 : created a function for handle the key press on tabs
            if (!e?.ctrlKey && e?.key === 'Enter') {
                let temp = document.getElementById(activeButton);
                temp?.click();
                e?.preventDefault();
            }
        }

    };

    //BT-96728 - Global Search Feature : ManasaB : 22/07/2023 - Start
    const saveToLocalStorage = (arrScripUpdated) => {
        setEncryptLocalStorage('RECENTLY_SEARCHED', JSON.stringify(arrScripUpdated));
    };

    const handleOnClickScrip = (arrScripData, isOpenOverview = true) => {
        let searchArray = JSON.parse(getDecryptLocalStorage('RECENTLY_SEARCHED'));
        if (searchArray?.length > 0) {
            let objActiveUserRecentSearch = searchArray?.find((each) => each?.user_id === objLoginSession?.data?.user_id);
            if (objActiveUserRecentSearch && Object.keys(objActiveUserRecentSearch)?.length) {
                let nIndex = objActiveUserRecentSearch?.arrRecentScrips?.findIndex(eachScrip => eachScrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === arrScripData[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]);
                if (nIndex !== -1) {
                    if (nIndex > 0) {
                        objActiveUserRecentSearch.arrRecentScrips.splice(nIndex, 1);
                        const updatedUserSearch = { user_id: objLoginSession?.data?.user_id, arrRecentScrips: [arrScripData, ...objActiveUserRecentSearch?.arrRecentScrips] };
                        const indexOfObject = searchArray.findIndex((each) => each?.user_id === objLoginSession?.data?.user_id);
                        if (indexOfObject !== -1) {
                            searchArray[indexOfObject] = updatedUserSearch;
                        } else {
                            searchArray.push(updatedUserSearch);
                        }
                        dispatch(setArrRecentlySearchScrips(updatedUserSearch));
                        saveToLocalStorage(searchArray);
                    }
                    else {
                        //ManasaB : 21-08-2024 : Hotfix Issue : Start
                        // const updatedUserSearch = { user_id: objLoginSession?.data?.user_id, arrRecentScrips: [arrScripData, ...objActiveUserRecentSearch.arrRecentScrips] };
                        // const indexOfObject = searchArray?.findIndex((each) => each?.user_id === objLoginSession?.data?.user_id);
                        // if (indexOfObject != -1) {
                        //     searchArray[indexOfObject] = updatedUserSearch;
                        // } else {
                        //     searchArray.push(updatedUserSearch);
                        // }
                        // dispatch(setArrRecentlySearchScrips(updatedUserSearch));
                        // saveToLocalStorage(searchArray);
                        //ManasaB : 21-08-2024 : Hotfix Issue : End
                    }
                }
                else {
                    const updatedUserSearch = { user_id: objLoginSession?.data?.user_id, arrRecentScrips: [arrScripData, ...objActiveUserRecentSearch?.arrRecentScrips] };
                    const indexOfObject = searchArray.findIndex((each) => each?.user_id === objLoginSession?.data?.user_id);
                    if (indexOfObject !== -1) {
                        searchArray[indexOfObject] = updatedUserSearch;
                    } else {
                        searchArray.push(updatedUserSearch);
                    }
                    dispatch(setArrRecentlySearchScrips(updatedUserSearch));
                    saveToLocalStorage(searchArray);
                }
            } else {
                const updatedUserSearch = { user_id: objLoginSession?.data?.user_id, arrRecentScrips: [arrScripData] };
                searchArray.push(updatedUserSearch);
                dispatch(setArrRecentlySearchScrips(updatedUserSearch));
                saveToLocalStorage(searchArray);
            }
        }
        else {
            const objeNewsUser = { user_id: objLoginSession?.data?.user_id, arrRecentScrips: [arrScripData] };
            const localArray = [objeNewsUser];
            dispatch(setArrRecentlySearchScrips(objeNewsUser));
            saveToLocalStorage(localArray);

        }
        if (isOpenOverview) {
            setShow(false);
            dispatch(setScripOverviewData(arrScripData));
            dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': true }]));
        }
    };
    //BT-96728 - Global Search Feature : ManasaB : 22/07/2023 - End

    // Hari k: 05-03-2024: BT-96728 gloabla seach IPO section-start
    const handleIPO = useCallback((selectedScrip) => {
        if (location?.pathname !== LOCATIONS.DASHBOARD) {
            navigate(LOCATIONS.DASHBOARD);
        } else { }
        setTimeout(() => {
            dispatch(handleModalData({ section: "IPO", IPOCode: selectedScrip?.IPOCode, ipoType: selectedScrip?.bidStatus, data: selectedScrip }));
            dispatch(handleModal([{ [IPO_MODALS.IPO_DETAILS_MODAL]: true }]));
        }, 100);

        setShow(false);


    }, [dispatch, setShow, location, navigate]);
    // Hari k: 05-03-2024: BT-96728 gloabla seach IPO section-end



    const checkExisting = useCallback((each) => {
        let value = scripDetails?.some(element => element?.[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === each?.[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN])
            ?
            true
            : false;
        return value;

    }, [scripDetails]);

    const handleScrips = useCallback((event, each, type) => {
        if (type === 'remove') {
            removeScrips(event, each);
        } else if (type === 'add') {
            addScrips(event, each);
        } else { }
    }, [removeScrips, addScrips]);
    //Handling functions for On click of forward icon in each tab : Manasa B : 24/08/2023 - End

    //ManasaB : 10-09-2024 : Hotfix issue - Start
    useEffect(() => {
        if (isSpanMargin && strSearchInputText.length >= GLOBAL_SEARCH_MIN_LENGTH) {
            if (arrFutScrips.length == 0 && arrOptScrips.length == 0) {
                setBIsNoDataSpanMargin(true);
            }
            else {
                setBIsNoDataSpanMargin(false);
            }
        }
    }, [isSpanMargin, arrFutScrips, arrOptScrips, objSearchScripData, bIsNoDataSpanMargin, strSearchInputText]);
    //ManasaB : 10-09-2024 : Hotfix issue - End
    const isGuestUser = Object?.keys(objLoginSession)?.includes('guestMode') || Object?.keys(objLoginSession?.data)?.includes('trial_expired');
    return (
        <>
            {(isSearchScrips || (arrEqScrips?.length > 0 || arrPages?.length > 0)) || (orderBookSearchModal) ?
                <div className={bSpanMargin ? 'calculators-innercard-search' : 'watchlist-search'}>
                    <div className='watchlist-tabs-wrap'>
                        {loading ? (Array.from({ length: numLoader ? numLoader : 3 }, (_, i) => i + 1)?.map(() =>
                            <div data-testid='skeleton-loader-global-search' className='d-flex' ref={loaderRef}>
                                <Container fluid className='px-3 py-2'>
                                    <Row className='g-0'>
                                        <Col md={8} className='d-flex'>
                                            <Container fluid className='p-0'>
                                                <Row className='g-0'>
                                                    <Col className='d-flex justify-content-start align-items-center'>
                                                        <Skeleton count={1} height={20} width={150} />
                                                    </Col>
                                                </Row>
                                                <Row className='g-0 pt-1'>
                                                    <Col className='d-flex justify-content-start align-items-center'>
                                                        <Skeleton inline={true} count={1} height={20} width={50} />
                                                        <Skeleton inline={true} count={1} height={20} width={180} className='ms-3' />
                                                    </Col>
                                                </Row>
                                            </Container>
                                        </Col>
                                        <Col md={4} className='d-flex justify-content-end align-items-center'>
                                            <Skeleton inline={true} count={4} height={30} width={30} className='ms-2' />
                                        </Col>
                                    </Row>
                                </Container>
                            </div>)) : objSearchScripData.status && bIsNoDataSpanMargin == false ? //ManasaB :10-09-2024 : Hotfix issue //ManasaB :10-09-2024 : Hotfix issue
                            <>
                                <div className='watchlist-tabs-header'>
                                    {(arrEqScrips?.length > 0 || arrFutScrips.length > 0 || arrOptScrips.length > 0 || arrAllScrips?.length > 0 || arrPages?.length > 0 || arrIPOScrips?.length > 0) &&
                                        <>
                                            {/*  Ameersha N [06-12-2023] : BT-96728 Global Search Feature - Toggling right and left icons only on global */}
                                            {/* {isGlobal &&
                                                <div className='d-flex justify-content-between align-items-center pt-2 mx-1'>
                                                    <button class="btn btn-sm globle-search-controler"> <div class="icon-10 icon-arrowleft icon-dark"></div></button>
                                                    <button class="btn btn-sm globle-search-controller"> <div class="icon-10 icon-arrowright icon-dark"></div></button>
                                                </div>
                                            } */}
                                            {/*  Ameersha N [06-12-2023] : BT-96728 Global Search Feature - Toggling right and left icons only on global */}
                                            <BzTabs className='watchlist-tabs px-4 my-2'>   {/* Bhagyashri P [04-12-2023] : BT-96728 Global Search Feature - class changes  */}
                                                {/* BT-114263 : Removing "All" tab and Adding count in search tabs : ManasaB : 24/07/2023  */}
                                                {isGuestUser ? (isDefaultAllTab && arrAllScrips?.length > 0) && <BzTab tabindex={nActiveCard >= 0 ? -1 : 0} id={'all'} onKeyDown={handleKeyPressOnTabs} onClick={(e) => handleSearchTabsOnClick(e, 'all')} className='watchlist-link' isActive={strSearchActiveTab === 'all'} tabKey="all">All{`(${nAllCount})`}</BzTab> : <>
                                                    {
                                                        isDefaultAllTab && objLoginSession?.data?.bcastExchanges && objLoginSession?.data?.bcastExchanges?.length > 0 && arrAllScrips?.length > 0 && objLoginSession?.data?.bcastExchanges.some(exchange => exchange.includes('EQ')) &&
                                                        <BzTab data-testid='global-search-all-tab' tabindex={nActiveCard >= 0 ? -1 : 0} id={'all'} onKeyDown={handleKeyPressOnTabs} onClick={(e) => handleSearchTabsOnClick(e, 'all')} className='watchlist-link' isActive={strSearchActiveTab === 'all'} tabKey="all">All{`(${nAllCount})`}</BzTab>
                                                    }</>
                                                }
                                                {isGuestUser ? !isSpanMargin && arrEqScrips.length > 0 && <BzTab tabindex={nActiveCard >= 0 ? -1 : 0} id={GLOBAL_SEARCH_TABS.EQUITY} onKeyDown={handleKeyPressOnTabs} onClick={(e) => handleSearchTabsOnClick(e, GLOBAL_SEARCH_TABS.EQUITY)} className='watchlist-link' isActive={strSearchActiveTab === GLOBAL_SEARCH_TABS.EQUITY} tabKey={GLOBAL_SEARCH_TABS.EQUITY}>Equity{`(${nEQCount})`}</BzTab> : <>
                                                    {!isSpanMargin &&
                                                        objLoginSession?.data?.bcastExchanges && objLoginSession?.data?.bcastExchanges?.length > 0 && arrEqScrips.length > 0 && objLoginSession?.data?.bcastExchanges.some(exchange => exchange.includes('EQ')) &&
                                                        <BzTab data-testid='global-search-equity-tab' tabindex={nActiveCard >= 0 ? -1 : 0} id={GLOBAL_SEARCH_TABS.EQUITY} onKeyDown={handleKeyPressOnTabs} onClick={(e) => handleSearchTabsOnClick(e, GLOBAL_SEARCH_TABS.EQUITY)} className='watchlist-link' isActive={strSearchActiveTab === GLOBAL_SEARCH_TABS.EQUITY} tabKey={GLOBAL_SEARCH_TABS.EQUITY}>Equity{`(${nEQCount})`}</BzTab>
                                                    }</>
                                                }
                                                {isGuestUser ? arrFutScrips.length > 0 && <BzTab tabindex={nActiveCard >= 0 ? -1 : 0} id={GLOBAL_SEARCH_TABS.FUTURES} onKeyDown={handleKeyPressOnTabs} onClick={(e) => handleSearchTabsOnClick(e, GLOBAL_SEARCH_TABS.FUTURES)} className='watchlist-link' isActive={strSearchActiveTab === GLOBAL_SEARCH_TABS.FUTURES} tabKey={GLOBAL_SEARCH_TABS.FUTURES}>Future{`(${nFUCount})`}</BzTab> : <>
                                                    {
                                                        objLoginSession?.data?.bcastExchanges && objLoginSession?.data?.bcastExchanges?.length > 0 && objLoginSession?.data?.bcastExchanges.some(exchange => exchange.includes('FO')) && arrFutScrips.length > 0 &&
                                                        <BzTab data-testid='global-search-future-tab' tabindex={nActiveCard >= 0 ? -1 : 0} id={GLOBAL_SEARCH_TABS.FUTURES} onKeyDown={handleKeyPressOnTabs} onClick={(e) => handleSearchTabsOnClick(e, GLOBAL_SEARCH_TABS.FUTURES)} className='watchlist-link' isActive={strSearchActiveTab === GLOBAL_SEARCH_TABS.FUTURES} tabKey={GLOBAL_SEARCH_TABS.FUTURES}>Future{`(${nFUCount})`}</BzTab>
                                                    }</>
                                                }
                                                {isGuestUser ? arrOptScrips.length > 0 && <BzTab tabindex={nActiveCard >= 0 ? -1 : 0} id={GLOBAL_SEARCH_TABS.OPTIONS} onKeyDown={handleKeyPressOnTabs} onClick={(e) => handleSearchTabsOnClick(e, GLOBAL_SEARCH_TABS.OPTIONS)} className='watchlist-link' isActive={strSearchActiveTab === GLOBAL_SEARCH_TABS.OPTIONS} tabKey={GLOBAL_SEARCH_TABS.OPTIONS}>Options{`(${nOPCount})`}</BzTab> : <>
                                                    {
                                                        objLoginSession?.data?.bcastExchanges && objLoginSession?.data?.bcastExchanges?.length > 0 && objLoginSession?.data?.bcastExchanges.some(exchange => exchange.includes('FO')) && arrOptScrips.length > 0 &&
                                                        <BzTab data-testid='global-search-option-tab' tabindex={nActiveCard >= 0 ? -1 : 0} id={GLOBAL_SEARCH_TABS.OPTIONS} onKeyDown={handleKeyPressOnTabs} onClick={(e) => handleSearchTabsOnClick(e, GLOBAL_SEARCH_TABS.OPTIONS)} className='watchlist-link' isActive={strSearchActiveTab === GLOBAL_SEARCH_TABS.OPTIONS} tabKey={GLOBAL_SEARCH_TABS.OPTIONS}>Options{`(${nOPCount})`}</BzTab>
                                                    }</>
                                                }
                                                {/* BT-115300 : Implementing search functionality for News : Manasa B : 24/08/2023 - Start */}

                                                {isDefaultAllTab !== false && isSpanMargin === false && <>
                                                    {isGuestUser ? arrFilteredNews?.length > 0 && <BzTab data-testid='global-search-equity-tab' tabindex={nActiveCard >= 0 ? -1 : 0} id={GLOBAL_SEARCH_TABS.NEWS} onKeyDown={handleKeyPressOnTabs} onClick={(e) => handleSearchTabsOnClick(e, GLOBAL_SEARCH_TABS.NEWS)} className='watchlist-link' isActive={strSearchActiveTab === GLOBAL_SEARCH_TABS.NEWS} tabKey={GLOBAL_SEARCH_TABS.NEWS}>News{`(${nNewsCount})`}</BzTab> : <>

                                                        {
                                                            objLoginSession?.data?.bcastExchanges && objLoginSession?.data?.bcastExchanges?.length > 0 && objLoginSession?.data?.bcastExchanges.some(exchange => exchange.includes('FO')) && arrFilteredNews?.length > 0 &&
                                                            <BzTab  data-testid='global-search-news-tab' tabindex={nActiveCard >= 0 ? -1 : 0} id={GLOBAL_SEARCH_TABS.NEWS} onKeyDown={handleKeyPressOnTabs} onClick={(e) => handleSearchTabsOnClick(e, GLOBAL_SEARCH_TABS.NEWS)} className='watchlist-link' isActive={strSearchActiveTab === GLOBAL_SEARCH_TABS.NEWS} tabKey={GLOBAL_SEARCH_TABS.NEWS}>News{`(${nNewsCount})`}</BzTab>
                                                        }</>
                                                    }
                                                    {/* BT-115300 : Implementing search functionality for News : Manasa B : 24/08/2023 - End */}
                                                    {/* BT-115298 ,BT-115303 : Implementing search functionality for Recommendation,ALerts : ManasaB : 16/08/2023 - Start */}
                                                    {isGuestUser ? arrFilteredRecoScrips?.length > 0 && <BzTab data-testid='global-search-recommendation-tab' tabindex={nActiveCard >= 0 ? -1 : 0} id={GLOBAL_SEARCH_TABS.RECOMMENDATIONS} onKeyDown={handleKeyPressOnTabs} onClick={(e) => handleSearchTabsOnClick(e, GLOBAL_SEARCH_TABS.RECOMMENDATIONS)} className='watchlist-link' isActive={strSearchActiveTab === GLOBAL_SEARCH_TABS.RECOMMENDATIONS} tabKey={GLOBAL_SEARCH_TABS.RECOMMENDATIONS}>Recommendations{`(${nRecommendationCount})`}</BzTab> : <>
                                                        {
                                                            objLoginSession?.data?.bcastExchanges && objLoginSession?.data?.bcastExchanges?.length > 0 && objLoginSession?.data?.bcastExchanges.some(exchange => exchange.includes('FO')) && arrFilteredRecoScrips?.length > 0 &&
                                                            <BzTab data-testid='global-search-recommendation-tab' tabindex={nActiveCard >= 0 ? -1 : 0} id={GLOBAL_SEARCH_TABS.RECOMMENDATIONS} onKeyDown={handleKeyPressOnTabs} onClick={(e) => handleSearchTabsOnClick(e, GLOBAL_SEARCH_TABS.RECOMMENDATIONS)} className='watchlist-link' isActive={strSearchActiveTab === GLOBAL_SEARCH_TABS.RECOMMENDATIONS} tabKey={GLOBAL_SEARCH_TABS.RECOMMENDATIONS}>Recommendations{`(${nRecommendationCount})`}</BzTab>
                                                        }</>
                                                    }
                                                    {isGuestUser ? arrFilteredAlerts?.length > 0 && <BzTab data-testid='global-search-alerts-tab' tabindex={nActiveCard >= 0 ? -1 : 0} id={GLOBAL_SEARCH_TABS.ALERTS} onKeyDown={handleKeyPressOnTabs} onClick={(e) => handleSearchTabsOnClick(e, GLOBAL_SEARCH_TABS.ALERTS)} className='watchlist-link' isActive={strSearchActiveTab === GLOBAL_SEARCH_TABS.ALERTS} tabKey={GLOBAL_SEARCH_TABS.ALERTS}>Alerts{`(${nAlertsCount})`}</BzTab> : <>
                                                        {
                                                            objLoginSession?.data?.bcastExchanges && objLoginSession?.data?.bcastExchanges?.length > 0 && objLoginSession?.data?.bcastExchanges.some(exchange => exchange.includes('FO')) && arrFilteredAlerts?.length > 0 &&
                                                            <BzTab data-testid='global-search-alerts-tab' tabindex={nActiveCard >= 0 ? -1 : 0} id={GLOBAL_SEARCH_TABS.ALERTS} onKeyDown={handleKeyPressOnTabs} onClick={(e) => handleSearchTabsOnClick(e, GLOBAL_SEARCH_TABS.ALERTS)} className='watchlist-link' isActive={strSearchActiveTab === GLOBAL_SEARCH_TABS.ALERTS} tabKey={GLOBAL_SEARCH_TABS.ALERTS}>Alerts{`(${nAlertsCount})`}</BzTab>
                                                        }</>
                                                    }
                                                    {/* BT-115298 ,BT-115303 : Implementing search functionality for Recommendation,ALerts : ManasaB : 16/08/2023 - End */}
                                                    {/* BT-115299 : Implementing search functionality for Events : ManasaB : 17/08/2023 - Start */}
                                                    {isGuestUser ? arrFilteredEvents?.length > 0 && <BzTab data-testid='global-search-events-tab' tabindex={nActiveCard >= 0 ? -1 : 0} id={GLOBAL_SEARCH_TABS.EVENTS} onKeyDown={handleKeyPressOnTabs} onClick={(e) => handleSearchTabsOnClick(e, GLOBAL_SEARCH_TABS.EVENTS)} className='watchlist-link' isActive={strSearchActiveTab === GLOBAL_SEARCH_TABS.EVENTS} tabKey={GLOBAL_SEARCH_TABS.EVENTS}>Events{`(${nEventsCount})`}</BzTab> : <>
                                                        {
                                                            objLoginSession?.data?.bcastExchanges && objLoginSession?.data?.bcastExchanges?.length > 0 && objLoginSession?.data?.bcastExchanges.some(exchange => exchange.includes('FO')) && arrFilteredEvents?.length > 0 &&
                                                            <BzTab data-testid='global-search-events-tab' tabindex={nActiveCard >= 0 ? -1 : 0} id={GLOBAL_SEARCH_TABS.EVENTS} onKeyDown={handleKeyPressOnTabs} onClick={(e) => handleSearchTabsOnClick(e, GLOBAL_SEARCH_TABS.EVENTS)} className='watchlist-link' isActive={strSearchActiveTab === GLOBAL_SEARCH_TABS.EVENTS} tabKey={GLOBAL_SEARCH_TABS.EVENTS}>Events{`(${nEventsCount})`}</BzTab>
                                                        }</>
                                                    }
                                                    {/* BT-115299 : Implementing search functionality for Events : ManasaB : 17/08/2023 - End */}
                                                    {/* BT-115302 : Implementing search functionality for IPO : Manasa B : 24/08/2023 - Start */}
                                                    {isGuestUser ? arrIPOScrips?.length > 0 && <BzTab tabindex={nActiveCard >= 0 ? -1 : 0} id={GLOBAL_SEARCH_TABS.IPO} onKeyDown={handleKeyPressOnTabs} onClick={(e) => handleSearchTabsOnClick(e, GLOBAL_SEARCH_TABS.IPO)} className='watchlist-link' isActive={strSearchActiveTab === GLOBAL_SEARCH_TABS.IPO} tabKey={GLOBAL_SEARCH_TABS.IPO}>IPO{`(${nIPOCount})`}</BzTab> : <>
                                                        {
                                                            objLoginSession?.data?.bcastExchanges && objLoginSession?.data?.bcastExchanges?.length > 0 && objLoginSession?.data?.bcastExchanges.some(exchange => exchange.includes('FO')) && arrIPOScrips?.length > 0 &&
                                                            <BzTab tabindex={nActiveCard >= 0 ? -1 : 0} id={GLOBAL_SEARCH_TABS.IPO} onKeyDown={handleKeyPressOnTabs} onClick={(e) => handleSearchTabsOnClick(e, GLOBAL_SEARCH_TABS.IPO)} className='watchlist-link' isActive={strSearchActiveTab === GLOBAL_SEARCH_TABS.IPO} tabKey={GLOBAL_SEARCH_TABS.IPO}>IPO{`(${nIPOCount})`}</BzTab>
                                                        }</>
                                                    }

                                                    {/* BT-115302 : Implementing search functionality for IPO : Manasa B : 24/08/2023 - End */}
                                                    {isGuestUser ? arrPages && arrPages?.length > 0 && <BzTab data-testid='global-search-pages-tab' tabindex={nActiveCard >= 0 ? -1 : 0} id={GLOBAL_SEARCH_TABS.PAGES} onKeyDown={handleKeyPressOnTabs} onClick={(e) => handleSearchTabsOnClick(e, GLOBAL_SEARCH_TABS.PAGES)} className='watchlist-link' isActive={strSearchActiveTab === GLOBAL_SEARCH_TABS.PAGES} tabKey={GLOBAL_SEARCH_TABS.PAGES}>Pages{`(${nPageCount})`}</BzTab> : <>
                                                        {
                                                            arrPages && arrPages?.length > 0 &&
                                                            <BzTab data-testid='global-search-pages-tab' tabindex={nActiveCard >= 0 ? -1 : 0} id={GLOBAL_SEARCH_TABS.PAGES} onKeyDown={handleKeyPressOnTabs} onClick={(e) => handleSearchTabsOnClick(e, GLOBAL_SEARCH_TABS.PAGES)} className='watchlist-link' isActive={strSearchActiveTab === GLOBAL_SEARCH_TABS.PAGES} tabKey={GLOBAL_SEARCH_TABS.PAGES}>Page{`(${nPageCount})`}</BzTab>
                                                        }</>
                                                    }
                                                </>

                                                }
                                            </BzTabs>
                                        </>
                                    }
                                </div>

                                <div onScroll={handleSearchScripsScroll} className={`watchlist-tabs-content ${isExpand ? 'watchlist-tabs-content-expand' : ''}`} >
                                    {orderBookSearchModal !== true ? //BREEZE-5912 : Order Cart for Derivative segment : LLD : ManasaB : 08-04-2025 : Remove restriction to show only eq scrips - Start

                                        <BzTabsContainer>
                                            <BzTabsContent tabKey='all' showDefault isActive={strSearchActiveTab === 'all'}>
                                                <TabAllContent strSearchActiveTab={GLOBAL_SEARCH_TABS.ALL} handleScrips={handleScrips} checkExisting={checkExisting} isSpanMargin={isSpanMargin} arrScrips={arrAllScrips} onBuySellClick={onBuySellClick} addScrips={addScrips} removeScrips={removeScrips} scripDetails={scripDetails}
                                                    handleOnClickScrip={handleOnClickScrip} nActiveCard={nActiveCard}//Ameersha N-20-11-2023 - BT-95888 Breeze Create Watchlist - issue -logic to open scrip over onclick of scrip name in all tab
                                                    availableOptions={availableOptions} activeButton={activeButton}
                                                    onKeyDown={handleKeyPressOnTabs} setAvailableOptions={setAvailableOptions} tab={strSearchActiveTab}
                                                />
                                            </BzTabsContent>
                                            {/* BT-113516 Adding /Removing scrips through inline search in watchlist : Manasa B : 17/07/2023 : Added scripdetails - Start  */}
                                            {/* BT-96728 - Global Search Feature : ManasaB : 26/07/2023 - Added handleOnClickScrip- Start */}
                                            {!isSpanMargin && <BzTabsContent tabKey={GLOBAL_SEARCH_TABS.EQUITY} showDefault isActive={strSearchActiveTab === GLOBAL_SEARCH_TABS.EQUITY}>
                                                <TabEquityContent tab={strSearchActiveTab} activeButton={activeButton} strSearchActiveTab={GLOBAL_SEARCH_TABS.EQUITY} nActiveCard={nActiveCard} handleScrips={handleScrips} checkExisting={checkExisting} arrEQScrips={arrEqScrips} scripDetails={scripDetails} onBuySellClick={onBuySellClick} addScrips={addScrips} removeScrips={removeScrips} handleOnClickScrip={handleOnClickScrip} availableOptions={availableOptions} onKeyDown={handleKeyPressOnTabs} setAvailableOptions={setAvailableOptions} />
                                            </BzTabsContent>}
                                            <BzTabsContent tabKey={GLOBAL_SEARCH_TABS.FUTURES} showDefault isActive={strSearchActiveTab === GLOBAL_SEARCH_TABS.FUTURES}>
                                                <TabFutureContent tab={strSearchActiveTab} activeButton={activeButton} setNActiveCard={setNActiveCard} strSearchActiveTab={GLOBAL_SEARCH_TABS.FUTURES} nActiveCard={nActiveCard} handleScrips={handleScrips} checkExisting={checkExisting} isSpanMargin={isSpanMargin} arrFUTScrips={arrFutScrips} scripDetails={scripDetails} onBuySellClick={onBuySellClick} addScrips={addScrips} removeScrips={removeScrips} handleOnClickScrip={handleOnClickScrip} availableOptions={availableOptions} onKeyDown={handleKeyPressOnTabs} setAvailableOptions={setAvailableOptions} />
                                            </BzTabsContent>
                                            <BzTabsContent tabKey={GLOBAL_SEARCH_TABS.OPTIONS} showDefault isActive={strSearchActiveTab === GLOBAL_SEARCH_TABS.OPTIONS}>
                                                {((isDefaultAllTab || isSpanMargin) && !isGlobalSearch) ? <TabOptionsListContent onKeyDown={handleKeyPressOnTabs} tab={strSearchActiveTab} activeButton={activeButton} availableOptions={availableOptions} setAvailableOptions={setAvailableOptions} nActiveCard={nActiveCard} strSearchActiveTab={GLOBAL_SEARCH_TABS.OPTIONS} handleScrips={handleScrips} checkExisting={checkExisting} isSpanMargin={isSpanMargin} setShow={setShow} arrOPScrips={arrOptScrips} scripDetails={scripDetails} onBuySellClick={onBuySellClick} addScrips={addScrips} removeScrips={removeScrips} handleOnClickScrip={handleOnClickScrip} /> :
                                                    <TabOptionsContent tab={strSearchActiveTab} onKeyDown={handleKeyPressOnTabs} activeButton={activeButton} availableOptions={availableOptions} setAvailableOptions={setAvailableOptions} strSearchActiveTab={GLOBAL_SEARCH_TABS.OPTIONS} nActiveCard={nActiveCard} setShow={setShow} arrOPScrips={arrOptScrips} scripDetails={scripDetails} onBuySellClick={onBuySellClick} addScrips={addScrips} removeScrips={removeScrips} handleOnClickScrip={handleOnClickScrip} />}
                                            </BzTabsContent>
                                            {/* BT-115300 : Implementing search functionality for News : Manasa B : 24/08/2023 - Start */}
                                            <BzTabsContent tabKey={GLOBAL_SEARCH_TABS.NEWS} showDefault isActive={strSearchActiveTab === GLOBAL_SEARCH_TABS.NEWS}>
                                                <TabNewsContent tab={strSearchActiveTab} activeButton={activeButton}
                                                    availableOptions={availableOptions} setAvailableOptions={setAvailableOptions} strSearchActiveTab={GLOBAL_SEARCH_TABS.NEWS} nActiveCard={nActiveCard} arrNewsScrips={arrFilteredNews} scripDetails={scripDetails} onBuySellClick={onBuySellClick} addScrips={addScrips} removeScrips={removeScrips} handleOnClickScrip={handleOnClickScrip} handleNewsOverview={handleNewsOverview} />
                                            </BzTabsContent>
                                            {/* BT-115300 : Implementing search functionality for News : Manasa B : 24/08/2023 - End */}
                                            {/* BT-115298 ,BT-115303 : Implementing search functionality for Recommendation,ALerts : ManasaB : 16/08/2023 - Start */}
                                            <BzTabsContent tabKey={GLOBAL_SEARCH_TABS.RECOMMENDATIONS} showDefault isActive={strSearchActiveTab === GLOBAL_SEARCH_TABS.RECOMMENDATIONS}>
                                                <TabRecommContent tab={strSearchActiveTab} activeButton={activeButton}
                                                    availableOptions={availableOptions} setAvailableOptions={setAvailableOptions} arrRecommScrips={arrFilteredRecoScrips} scripDetails={scripDetails} onBuySellClick={onBuySellClick} addScrips={addScrips} removeScrips={removeScrips} handleOnClickScrip={handleOnClickScrip} onBuySellClickRecomm={onBuySellClickRecomm} />
                                            </BzTabsContent>
                                            <BzTabsContent tabKey={GLOBAL_SEARCH_TABS.ALERTS} showDefault isActive={strSearchActiveTab === GLOBAL_SEARCH_TABS.ALERTS}>
                                                <TabAlertsContent tab={strSearchActiveTab} activeButton={activeButton}
                                                    availableOptions={availableOptions} setAvailableOptions={setAvailableOptions} arrAlertScrips={arrFilteredAlerts} scripDetails={scripDetails} onBuySellClick={onBuySellClick} addScrips={addScrips} removeScrips={removeScrips} handleOnClickScrip={handleOnClickScrip} handleEditAlert={handleEditAlert} />
                                            </BzTabsContent>
                                            {/* BT-115298 ,BT-115303 : Implementing search functionality for Recommendation,ALerts : ManasaB : 16/08/2023 - End */}
                                            {/* BT-115299 : Implementing search functionality for Events : ManasaB : 17/08/2023 - Start */}
                                            <BzTabsContent tabKey={GLOBAL_SEARCH_TABS.EVENTS} showDefault isActive={strSearchActiveTab === GLOBAL_SEARCH_TABS.EVENTS}>
                                                <TabEventsContent tab={strSearchActiveTab} activeButton={activeButton}
                                                    availableOptions={availableOptions} setAvailableOptions={setAvailableOptions} strSearchActiveTab={GLOBAL_SEARCH_TABS.EVENTS} nActiveCard={nActiveCard} arrEventScrips={arrFilteredEvents} scripDetails={scripDetails} onBuySellClick={onBuySellClick} addScrips={addScrips} removeScrips={removeScrips} handleOnClickScrip={handleOnClickScrip} handleOverview={handleOverview} />
                                            </BzTabsContent>
                                            {/* BT-115299 : Implementing search functionality for Events : ManasaB : 17/08/2023 - End */}
                                            {/* BT-115302 : Implementing search functionality for IPO : Manasa B : 24/08/2023 - Start */}
                                            <BzTabsContent tabKey={GLOBAL_SEARCH_TABS.IPO} showDefault isActive={strSearchActiveTab === GLOBAL_SEARCH_TABS.IPO}>
                                                <TabIPOContent tab={strSearchActiveTab} activeButton={activeButton}
                                                    availableOptions={availableOptions} setAvailableOptions={setAvailableOptions} strSearchActiveTab={GLOBAL_SEARCH_TABS.IPO} nActiveCard={nActiveCard} arrIPOScrips={arrIPOScrips} scripDetails={scripDetails} onBuySellClick={onBuySellClick} addScrips={addScrips} removeScrips={removeScrips} handleOnClickScrip={handleOnClickScrip} handleIPO={handleIPO} />
                                            </BzTabsContent>
                                            {/* BT-115302 : Implementing search functionality for IPO : Manasa B : 24/08/2023 - End */}
                                            {/* BT-96728 - Global Search Feature : ManasaB : 26/07/2023 - Added handleOnClickScrip- End */}
                                            {/* BT-113516 Adding /Removing scrips through inline search in watchlist : Manasa B : 17/07/2023 : Added scripdetails - End  */}
                                            <BzTabsContent tabKey={GLOBAL_SEARCH_TABS.PAGES} showDefault isActive={strSearchActiveTab === GLOBAL_SEARCH_TABS.PAGES}>
                                                <TabPagesContent tab={strSearchActiveTab} activeButton={activeButton}
                                                    availableOptions={availableOptions} setAvailableOptions={setAvailableOptions} strSearchActiveTab={GLOBAL_SEARCH_TABS.PAGES} nActiveCard={nActiveCard} arrPages={arrPages} scripDetails={scripDetails} handleSelectedPage={handleSelectedPage} />
                                            </BzTabsContent>
                                        </BzTabsContainer> : <BzTabsContainer>
                                            {/* BT-124975 : ManasaB :11/01/2024 : Order Cart : API Integration for Save Cart and Place Order : 29/02/2024 : Added existing functions seperately for B and S - Start */}
                                            <BzTabsContent tabKey='all' showDefault isActive={strSearchActiveTab === 'all'}>
                                                <TabAllContent strSearchActiveTab={GLOBAL_SEARCH_TABS.ALL} handleScrips={handleScrips} checkExisting={checkExisting} isSpanMargin={isSpanMargin} arrScrips={arrAllScrips} onBuySellClick={onBuySellClick} addScrips={addScrips} removeScrips={removeScrips} scripDetails={scripDetails}
                                                    handleOnClickScrip={handleOnClickScrip} nActiveCard={nActiveCard}//Ameersha N-20-11-2023 - BT-95888 Breeze Create Watchlist - issue -logic to open scrip over onclick of scrip name in all tab
                                                    availableOptions={availableOptions} activeButton={activeButton}
                                                    onKeyDown={handleKeyPressOnTabs} setAvailableOptions={setAvailableOptions} tab={strSearchActiveTab} orderBookSearchModal={orderBookSearchModal} checkBuyExisting={checkBuyExisting} checkSellExisting={checkSellExisting}
                                                />
                                            </BzTabsContent>
                                            {/* BT-124975 : ManasaB :11/01/2024 : Order Cart : API Integration for Save Cart and Place Order : 29/02/2024 : Added existing functions seperately for B and S - End */}
                                        </BzTabsContainer>}
                                </div>

                                {/* BT-106965 : Ordercart : SAT2 Issues : ManasaB : 03-06-2024 : Added orderBookSearchModal condition..Start */}
                                {(orderBookSearchModal !== true || isGlobal) &&
                                    <div className='watchlist-tabs-footer'>
                                        <form className='d-flex pt-2' onSubmit={(e) => e?.preventDefault()}>
                                            <Container fluid className='p-0 px-3'>
                                                <Row className='g-0'>
                                                    <Col xs={10} className='d-flex justify-content-start align-items-center'>
                                                        {isGlobal ? scripDetails.length > 0 ? <div className='font-regular font-size3 color-subtext me-2'>Add Selected Scrips</div> : null : (isSpanMargin ? <div className='font-regular font-size3 color-subtext me-2'>Add Selected Scrips</div> : <div className='font-regular font-size3 color-subtext me-2'>Add Scrip To</div>)}
                                                        <div className='font-medium font-size3 color-text text-uppercase me-2'>{strWatchlistName}</div>
                                                        {isGlobal ? scripDetails.length > 0 && <div data-testid='global-search-scrip-count-element' className='number-badge'> {scripDetails?.length}</div> : <div data-testid='global-search-scrip-count-element' className='number-badge'>{scripDetails?.length}</div>}
                                                    </Col>
                                                    <Col xs={2} className='d-flex justify-content-end align-items-center'>
                                                        {isGlobal ? scripDetails.length > 0 && <BzButton data-testid='global-search-done-button' className='btn btn-md btn-primary text-uppercase' onClick={onHandleDone}>Done</BzButton> : scripDetails.length > 0 && <BzButton data-testid="scrips-recommendations-dne-btn" className='btn btn-md btn-primary text-uppercase' onClick={onHandleDone}>Done</BzButton>}
                                                    </Col>
                                                </Row>
                                            </Container>
                                        </form>
                                    </div>
                                }
                                {/* BT-106965 : Ordercart : SAT2 Issues : ManasaB : 03-06-2024 :Added orderBookSearchModal condition  End */}
                            </>
                            :
                            <div data-testid='zero-state-global-search-label' className='zero-state-alerts zero-state-alerts-xl'>
                                <div className='icon-64 icon-nodata mrgauto mb-3'></div>
                                <div className='font-medium font-size4 color-text mb-1'>No matches found</div>
                                <div className='font-regular font-size2 color-nodata'>Try adjusting your search to find what you are looking for</div>
                            </div>
                        }
                    </div>


                </div> : null
            }

        </>
    );
};

export default memo(TabsScripsList);